// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"485":"95949aa6","834":"6a715198","884":"6e9c323a","893":"29785968"}[chunkId] + ".css";
};